import type { ApiClient, BookingView } from '@elite-residence/api-client';

type Booking = BookingView['booking'];

// Operations and dashboard counts need the complete authorized result, even
// when history spans several database pages. Never silently show a partial
// count after a later-page failure or repeated cursor.
export async function loadBookings(
  client: ApiClient,
  query: { branchId?: string; status?: string; from?: string; to?: string; customerId?: string } = {},
  signal?: AbortSignal,
): Promise<Booking[]> {
  const bookings: Booking[] = [];
  const cursors = new Set<string>();
  let cursor: string | undefined;
  do {
    const response = await client.listBookings(
      { query: { ...query, limit: '500', ...(cursor ? { cursor } : {}) } },
      signal ? { signal } : {},
    );
    if (response.status !== 200) throw new Error('bookings_unavailable');
    bookings.push(...response.body.bookings);
    cursor = response.body.nextCursor ?? undefined;
    if (cursor) {
      if (cursors.has(cursor)) throw new Error('bookings_cursor_repeated');
      cursors.add(cursor);
    }
  } while (cursor);
  return bookings;
}
